import produce from 'immer';

import {
  FETCH_PAYMENT_PORTAL_JWT_TOKEN_FAILURE,
  FETCH_PAYMENT_PORTAL_JWT_TOKEN_SUCCESS,
  FETCH_PAYMENT_PORTAL_PREFERENCES_FAILURE,
  FETCH_PAYMENT_PORTAL_PREFERENCES_SUCCESS,
  HOSTED_PAYMENT_PAGE_TOKEN_FAILURE,
  PAYMENT_PORTAL_CONFIG_FAILURE,
  PAYMENT_PORTAL_CONFIG_SUCCESS,
  PAYMENT_PORTAL_TRANSACTION_LISTING_FAILURE,
  PAYMENT_PORTAL_TRANSACTION_LISTING_SUCCESS,
  UPDATE_PAYMENT_PORTAL_PREFERENCES_FAILURE,
  UPDATE_PAYMENT_PORTAL_PREFERENCES_SUCCESS,
} from '@actions/paymentPortal';

const initialState: IPaymentPortalStore = {
  paymentPortalPrefrences: null,
  paymentPortalBalanceListing: null,
  paymentPortalJWTToken: null,
  config: null,
  error: null,
};

export default (state: IPaymentPortalStore = initialState, action: any) =>
  produce(state, (draftState: IPaymentPortalStore) => {
    switch (action.type) {
      case FETCH_PAYMENT_PORTAL_PREFERENCES_SUCCESS:
      case UPDATE_PAYMENT_PORTAL_PREFERENCES_SUCCESS:
        draftState.paymentPortalPrefrences = action.response;
        draftState.error = null;

        return;
      case FETCH_PAYMENT_PORTAL_PREFERENCES_FAILURE:
      case UPDATE_PAYMENT_PORTAL_PREFERENCES_FAILURE:
      case HOSTED_PAYMENT_PAGE_TOKEN_FAILURE:
        draftState.error = action.error;

        return;

      case PAYMENT_PORTAL_CONFIG_SUCCESS:
        draftState.config = action.response;
        draftState.error = null;

        return;

      case PAYMENT_PORTAL_CONFIG_FAILURE:
        draftState.config = null;
        draftState.error = action.error;

        return;

      case FETCH_PAYMENT_PORTAL_JWT_TOKEN_SUCCESS:
        draftState.paymentPortalJWTToken = action.response;
        draftState.error = null;

        return;

      case FETCH_PAYMENT_PORTAL_JWT_TOKEN_FAILURE:
        draftState.paymentPortalJWTToken = null;
        draftState.error = action.error;

        return;

      case PAYMENT_PORTAL_TRANSACTION_LISTING_SUCCESS:
        draftState.paymentPortalBalanceListing = action.response;
        draftState.error = null;

        return;

      case PAYMENT_PORTAL_TRANSACTION_LISTING_FAILURE:
        draftState.paymentPortalBalanceListing = null;
        draftState.error = action.error;

        return;

      default:
        return;
    }
  });
